var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C8.55228 1 9 1.44772 9 2V3L15 3V2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2V3C20.3137 3 23 5.68629 23 9V17C23 20.3137 20.3137 23 17 23H7C3.68629 23 1 20.3137 1 17L1 9C1 5.68629 3.68629 3 7 3V2C7 1.44772 7.44772 1 8 1ZM15 5V6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6V5C19.2091 5 21 6.79086 21 9V9.5L3 9.5V9C3 6.79086 4.79086 5 7 5V6C7 6.55228 7.44772 7 8 7C8.55228 7 9 6.55228 9 6V5L15 5ZM3 11.5L21 11.5V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17L3 11.5ZM7 17C7.55228 17 8 16.5523 8 16C8 15.4477 7.55228 15 7 15C6.44772 15 6 15.4477 6 16C6 16.5523 6.44772 17 7 17ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16ZM17 17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15C16.4477 15 16 15.4477 16 16C16 16.5523 16.4477 17 17 17Z",
    fill: "#006B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.8ff5f485d6074d96c64432f99fe784e4.svg";
export { ForwardRef as ReactComponent };